import React from 'react';
import { connect } from 'react-redux';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {
  Glyphicon,
} from 'react-bootstrap';
import { List, fromJS } from 'immutable';
import {
  Button,
} from '../../../form/FormControls.jsx';
import { filterExpense } from '@/component/blogic/deals/expenses/ExpensesElement';
import {
  tryToSaveDealPayment,
  updateDealPayment,
  addDealPayment,
  removeDealPayment,
  addDealExpense,
  updateDealExpense,
  removeDealExpense,
  updateTransportExpense,
  addTransportExpense,
  removeTransportExpense }
  from '../store/deal.store';
import { handleFormChanged, setExpensesRebuilded } from '@/store/allaround.store.js';
import { REF_PATH as OWNER_REF_PATH }
  from '@/component/dict/simple/owner/Const';
import { REF_PATH as INSURANCECOMPANY_REF_PATH }
  from '@/component/dict/simple/insurancecompany/Const';
import { REF_PATH as INSPECTIONCOMPANY_REF_PATH }
  from '@/component/dict/simple/inspectioncompany/Const';
import { REF_PATH as VESSEL_BROKER_REF_PATH }
  from '@/component/dict/simple/vesselbroker/Const';
import { REF_PATH as FORWARDER_REF_PATH }
  from '@/component/dict/simple/forwarder/Const';
import { REF_PATH as BUYER_REF_PATH }
  from '@/component/dict/simple/buyer/Const';
import { REF_PATH as SELLER_REF_PATH }
  from '@/component/dict/simple/supplier/Const';
import { REF_PATH as PRODUCER_TYPE_REF_PATH }
  from '@/component/dict/simple/producer/Const';
import { REF_PATH as TRADE_COUNTERPARTIES_REF_PATH }
  from '@/component/dict/simple/tradecounterparties/Const';
import {
  PaymentsContainer, mapStateToProps, BRIEF_MODE,
  paymentHasFinData, paymentHasSubpaymentsWithFinData, ApprovedIcon, UnapprovedIcon,
  PayedIcon, ResizeExpand, ResizeCollapse,
} from './PaymentsContainer';
import { validateRoleConfig } from '../../../auth/RoleConfigFilter.jsx';
import {
  sortPay, sortDRCR, sortDocumentNumber, sortSimpleText, sortPaymentAmount,
  sortPaymentDate, sortOutstanding, sortBankingCost, sortId, sortDueAmount,
} from './PaymentsSort';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
moment.locale('en');
momentLocalizer();

const dictList = `${INSURANCECOMPANY_REF_PATH},${INSPECTIONCOMPANY_REF_PATH}
,${FORWARDER_REF_PATH},${VESSEL_BROKER_REF_PATH}, ${PRODUCER_TYPE_REF_PATH}
,${OWNER_REF_PATH},${BUYER_REF_PATH},${SELLER_REF_PATH},
,${TRADE_COUNTERPARTIES_REF_PATH}`;

class CommonPaymentsContainer extends PaymentsContainer {
  constructor(props) {
    super(props);
    this.openModalEditAttrs = this.openModalEditAttrs.bind(this);
    this.closeModalEditAttrs = this.closeModalEditAttrs.bind(this);
    this.getTable = this.getTable.bind(this);
    this.canEdit = this.canEdit.bind(this);
  }

  componentWillMount() {
    super.componentWillMount();
    this.state = { ...this.state, hasAccessToEdit: validateRoleConfig(['financesViewEditDelete']) };
  }

  getCounterpartyDicts() {
    return dictList;
  }
  approveFormatter(value, row, formatExtraData, idx) {
    if (this.isTotalRow(row) || (!(this.props.isDebit || row.isDebit) && row.outstanding)) {
      return '';
    }
    let available = this.state.hasAccessToEdit;
    if (row.isDetached || (!this.isFinancialMode() && !row.isSubPartial)) {
      if (row.approve && paymentHasFinData(row)) {
        available = false;
      } else {
        if (value) {
          available = this.state.hasAccessToEdit;
        } else {
          available = row.approvedAvailable;
        }
      }
    }
    if (!(this.props.isDebit || row.isDebit)) {
      available = false;
    }
    let icon = <ApprovedIcon />;
    if (!value) {
      icon = <UnapprovedIcon />;
    }
    if ((value || !(this.props.isDebit || row.isDebit)) && !row.outstanding && row.dueAmount) {
      icon = <PayedIcon />;
    }
    return (
      <div id={`approve-${idx}-${this.isDirty(row)}`}>
        <input
          type="checkbox"
          defaultChecked={value}
          style={{ display: 'none' }}
        />
        {!this.hasSubpayments(row, true) && !row.isSubPartial
          ?
          <Button
            disabled={(!row.isDetached && this.isFinancialMode()) || !available}
            style={{ padding: 0 }}
            onClick={() => {
              this.updateDealPayment(
                this.getPaymentIndex(row, idx),
                this.paymentPreprocessor(row, 'approve', !value),
              );
              this.forceUpdate();
            }}
          >
            {icon}
          </Button>

          : ''
        }
      </div>
    );
  }

  canEditTopApprove() {
    return true;
  }

  canEdit(idx) {
    const payment = this.props.payments.get(idx);
    return validateRoleConfig(['financesViewEditDelete'])
      && !payment.get('approve') && !paymentHasFinData(payment)
      && !paymentHasSubpaymentsWithFinData(payment)
      && payment.get('payments', new List()).every(p => !p.get('approve'));
  }

  filterData(data, props = this.props) {
    if (!this.isSubpayment()) {
      let result = new List();
      const filterIds = props.filterIds.toJS();
      data.forEach((d) => {
        if (filterIds.includes(d.get('id'))) {
          result = result.push(d);
        }
      });
      return result;
    }
    return data;
  }

  filterExpenseData(data) {
    return filterExpense(data, 'commonPayment');
  }

  hideContractField() {
    return true;
  }

  hideVesselNameField() {
    return true;
  }

  canSortDRCR() {
    return true;
  }

  checkIfApprovedAvailable(rowArg, parent) {
    const row = rowArg.get ? rowArg.toJS() : rowArg;
    let parentElement = parent || row;
    if (parentElement.get) {
      parentElement = parentElement.toJS();
    }
    return { available: this.state.hasAccessToEdit && !!(row && parentElement.documentNumber
    && (parentElement.documentType || parentElement.documentType === 0)
    && (parentElement.expensesType || parentElement.expensesType === 0)
    && row.dueAmount && row.dueDate) };
  }


  dueAmountFormatter(value, row, formatExtraData, idx) {
    const isTotalRow = this.isTotalRow(row);
    const showAddSumpayment = this.state.hasAccessToEdit
      && !this.isSubpayment() && !row.approve && row.outstanding;
    const addSubPaymentButton = (<div
      id={`actions-addsub-${idx}-${this.isDirty(row)}`}
      style={showAddSumpayment ? { marginRight: -34, marginLeft: 5 } : {}}
    >
      {showAddSumpayment ?
        <div>
          <Button
            id="addSubPayment"
            bsStyle="link"
            onClick={() => this.handleAddSubPayment(row, row.paymentIdx)}
            style={{ padding: 0, border: 0, height: 28 }}
          >
            <Glyphicon
              style={{ cursor: 'pointer', fontSize: 28 }}
              glyph="indent-left"
              title="Add subpayment"
            />
          </Button>
        </div>
        : ''
      }
    </div>);
    return (
      this.isSubpartialTable() && formatExtraData == 'dueAmount' ?
        <div /> :
        <div
          className="dueAmount"
          style={{ justifyContent: 'flex-end' }}
          id={`dueAmount-${formatExtraData}-${idx}-${this.isDirty(row)}`}
        >
          {this.simpleTextFormatterWithCurrency(value, row, formatExtraData, idx)}
          {!isTotalRow ? addSubPaymentButton : ''}
        </div>
    );
  }

  handleAddSubPayment(row, idx) {
    let parent = this.props.payments.get(idx);
    if (parent) {
      const timeAdded = new Date().getTime();
      const payment = {
        parent: parent.get('id'),
        timeAdded,
        dealtype: this.props.dealType,
      };
      if (row.isDetached) {
        this.setState({ showModalEditAttrs: true, modalEditAttrsParent: parent });
      } else {
        // добавление частичного платежа выполняется первый раз
        if (!this.isSubpayment() && !this.hasSubpayments(row)) {
          parent = parent
            .set('dueDate', undefined)
            .set('paymentDate', undefined)
            .set('totalDueCost', undefined)
            .set('bankingCost', undefined)
            .set('paymentAmount', undefined);

          this.updateDealPayment(row.paymentIdx, parent);
        }
        this.props.addDealPayment(row.paymentIdx, payment);
      }
    }
  }

  canDelete(idx) {
    const payment = this.props.payments.get(idx);
    if (this.props.subpartial && !paymentHasSubpaymentsWithFinData(payment)
    && validateRoleConfig(['financesViewEditDelete'])) {
      return true;
    }
    return payment.get('isDetached')
      && !paymentHasSubpaymentsWithFinData(payment)
      && validateRoleConfig(['financesViewEditDelete']);
  }

  getTable() {
    const options = { ...this.finOptions, ...this.getPaginationOptions() };
    return (<BootstrapTable
      hover
      headerStyle={this.isSubpayment() ? { display: 'none' } : {}}
      bordered={false}
      className={this.tableClassName()}
      trClassName={this.validationClassname}
      data={this.state.nonSubPartialPayments}
      options={options}
      expandableRow={this.isExpandableRow}
      expandComponent={this.expandComponent}
      tableHeaderClass="payments-headers"
      pagination={!this.props.subpayment}
      ref="table"
      keyField="paymentKey"
      id="paymentsTable"
      search={!this.props.subpayment}
    >
      <TableHeaderColumn
        expandable={false}
        dataSort={!this.props.subpayment}
        sortFunc={sortPay}
        width="50px"
        dataField="approve"
        dataAlign="center" headerAlign="center"
        dataFormat={this.approveFormatter}
        searchable={false}
      >
        Pay
      </TableHeaderColumn>
      <TableHeaderColumn
        dataSort={!this.props.subpayment}
        sortFunc={sortId}
        dataField="id"
        hidden
      />
      <TableHeaderColumn
        expandable={false}
        width="40px"
        dataSort={this.canSortDRCR() && !this.props.subpayment}
        sortFunc={sortDRCR}
        dataField="isDebit"
        formatExtraData="isDebit"
        dataAlign="center" headerAlign="center"
        dataFormat={this.finDebitCreditFormatter}
        searchable={false}
      >
        DR/CR
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="45px"
        dataField="resolvedUser"
        columnClassName="payments-wrapped-text-td"
        dataAlign="right" headerAlign="right"
        dataFormat={this.finUserNameFormatter}
      >
        Ops
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="80px"
        dataSort={!this.props.subpayment}
        sortFunc={sortDocumentNumber}
        dataField="documentNumber"
        formatExtraData="documentNumber"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatter}
      >
        Document #
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="140px"
        dataSort={!this.props.subpayment}
        sortFunc={sortSimpleText('resolvedDocType')}
        dataField="resolvedDocType"
        formatExtraData="resolvedDocType"
        columnClassName="payments-wrapped-text-td"
        dataAlign="right" headerAlign="right"
        dataFormat={this.simpleTextFormatter}
      >
        Document type
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="140px"
        dataSort={!this.props.subpayment}
        sortFunc={sortSimpleText('resolvedType')}
        dataField="resolvedType"
        formatExtraData="resolvedType"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatter}
      >
        Type
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="140px"
        dataSort={!this.props.subpayment}
        sortFunc={sortSimpleText('counterpartyName')}
        dataField="counterpartyName"
        formatExtraData="counterpartyName"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatter}
      >
        Counterparty
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="130px"
        dataSort={!this.props.subpayment}
        sortFunc={sortDueAmount}
        dataField="resolvedDueAmount"
        formatExtraData="resolvedDueAmount"
        columnClassName="payments-money payments-wrapped-text-td"
        dataAlign="right" headerAlign="right"
        dataFormat={this.dueAmountFormatter}
      >
        Due Amount
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="114px"
        dataField="resolvedDueDate"
        dataSort={!this.props.subpayment}
        sortFunc={this.props.subpayment ? () => {
        } : this.sortDueDateInitial}
        formatExtraData="resolvedDueDate"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatter}
      >
        Due Date
      </TableHeaderColumn>

      <TableHeaderColumn
        expandable={false}
        width="120px"
        dataSort={!this.props.subpayment}
        sortFunc={sortPaymentAmount}
        dataField="resolvedPaymentAmount"
        formatExtraData="resolvedPaymentAmount"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatterWithCurrency}
      >
        Payment Amount
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="114px"
        dataField="resolvedPaymentDate"
        dataSort={!this.props.subpayment}
        sortFunc={sortPaymentDate}
        formatExtraData="resolvedPaymentDate"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatter}
      >
        Payment Date
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="100px"
        dataSort={!this.props.subpayment}
        sortFunc={sortOutstanding}
        dataField="resolvedOutstanding"
        formatExtraData="resolvedOutstanding"
        dataAlign="right" headerAlign="right"
        columnClassName={'payments-wrapped-text-td payments-money payments-outstanding'}
        dataFormat={this.simpleTextFormatter}
      >
        Outstanding
      </TableHeaderColumn>
      {this.state.viewMode != BRIEF_MODE && <TableHeaderColumn
        expandable={false}
        width="100px"
        dataSort={!this.props.subpayment}
        sortFunc={sortBankingCost}
        dataField="resolvedBankingCost"
        formatExtraData="resolvedBankingCost"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatterWithCurrency}
      >
        Banking Cost
      </TableHeaderColumn>
      }
      <TableHeaderColumn
        expandable={false}
        width="160px"
        dataField="bank"
        dataSort={!this.props.subpayment}
        sortFunc={sortSimpleText('resolvedBank')}
        dataField="resolvedBank"
        formatExtraData="resolvedBank"
        columnClassName="payments-wrapped-text-td"
        dataAlign="right" headerAlign="right"
        dataFormat={this.simpleTextFormatter}
      >
        Bank
      </TableHeaderColumn>
      {this.state.viewMode != BRIEF_MODE && <TableHeaderColumn
        expandable={false}
        width="160px"
        dataField="notes"
        formatExtraData="notes"
        dataAlign="right" headerAlign="right"
        dataFormat={this.textMultiFormatter}
      >
        Notes
      </TableHeaderColumn>
      }
      <TableHeaderColumn
        expandable={false}
        width="60px"
        dataField="document"
        formatExtraData="document"
        dataAlign="center" headerAlign="center"
        columnClassName={'payments-pre-last-columns'}
        className={'payments-pre-last-columns-header'}
        dataFormat={this.invoiceFormatter}
        searchable={false}
      />
      <TableHeaderColumn
        expandable={false}
        width="45px"
        dataField="idx"
        dataAlign="center" headerAlign="left"
        dataFormat={this.deleteButton}
        searchable={false}
        className={'payments-last-columns-header'}
        columnClassName={'payments-last-columns'}
      >
        <Button
          bsStyle="primary"
          className={'payments-expand-button'}
          onClick={this.changeViewMode}
        >
          {this.state.viewMode == BRIEF_MODE ? <ResizeExpand /> : <ResizeCollapse />}
        </Button>
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="45px"
        dataField="id"
        dataAlign="center" headerAlign="left"
        className={'payments-last-columns-header'}
        columnClassName={'payments-last-columns'}
        dataFormat={this.editSubPartialPaymentFormatter}
      />
      <TableHeaderColumn
        expandable={false}
        width="100px"
        dataField="id"
        dataAlign="center" headerAlign="left"
        className={'payments-last-columns-header'}
        columnClassName={'payments-last-columns payments-pay-column'}
        dataFormat={this.addSubPartialPaymentFormatter}
      />
    </BootstrapTable>);
  }

  expandComponent(row) {
    const isSubPartial = !!(row && row.payments && row.payments.find(p => p.isSubPartial));
    return (
      <InternalSubCommonPaymentsContainer
        productIdx={this.props.productIdx}
        paymentIdx={row.paymentIdx}
        parentPaymentIdx={this.props.paymentIdx}
        subpayment
        subpartial={isSubPartial}
        saving={this.props.saving}
        payments={fromJS(row.payments)}
        parentPayments={this.props.payments}
        mode={this.props.mode}
        viewMode={this.state.viewMode}
        dealType={this.props.dealType}
        contractNumber={this.props.contractNumber}
        currency={this.props.currency || row.dueAmountCurrency}
        isDebit={this.props.isDebit || row.isDebit}
        parentFailedValidation={row.dueAmountValid === false || this.props.parentFailedValidation}
      />
    );
  }


  tableClassName() {
    // eslint-disable-next-line
    return `${this.isSubpartialTable() ? 'sub-partial-table' :
      this.isSubpayment() ? 'sub-payment-table ' : 'commonpayments payments'}`;
  }
}

const InternalSubCommonPaymentsContainer = connect(mapStateToProps,
  (dispatch, props) => ({
    addDealPayment(paymentIdx, payment, isSubpayment, insertAt0) {
      const paymentIdxs = [];
      if (props.parentPaymentIdx >= 0) {
        paymentIdxs.push(props.parentPaymentIdx);
      }
      if (props.paymentIdx >= 0) {
        paymentIdxs.push(props.paymentIdx);
      }
      if (paymentIdx >= 0) {
        paymentIdxs.push(paymentIdx);
      }
      if (props.mode == 'financial') {
        tryToSaveDealPayment(dispatch, payment, props.productIdx, paymentIdxs, true, isSubpayment);
      } else {
        addDealPayment(dispatch, props.productIdx, paymentIdxs, payment, insertAt0);
        handleFormChanged(dispatch);
      }
    },
    updateDealPayment(paymentIdx, payment) {
      const paymentIdxs = [];
      if (props.parentPaymentIdx >= 0) {
        paymentIdxs.push(props.parentPaymentIdx);
      }
      if (props.paymentIdx >= 0) {
        paymentIdxs.push(props.paymentIdx);
      }
      if (paymentIdx >= 0) {
        paymentIdxs.push(paymentIdx);
      }
      if (props.mode == 'financial') {
        tryToSaveDealPayment(dispatch, payment, props.productIdx, paymentIdxs, false);
      } else {
        updateDealPayment(dispatch, props.productIdx, paymentIdxs, payment);
        handleFormChanged(dispatch);
      }
    },
    removeDealPayment(paymentIdx, id) {
      const paymentIdxs = [];
      if (props.parentPaymentIdx >= 0) {
        paymentIdxs.push(props.parentPaymentIdx);
      }
      if (props.paymentIdx >= 0) {
        paymentIdxs.push(props.paymentIdx);
      }
      removeDealPayment(dispatch, props.mode == 'financial', id,
        props.productIdx, paymentIdxs, paymentIdx);
      handleFormChanged(dispatch);
    },
    tryToSaveDealPayment(payment) {
      tryToSaveDealPayment(dispatch, payment);
    },
    addPaymentExpense(expense) {
      if (props.dealType == 'transport') {
        addTransportExpense(dispatch, expense);
      } else {
        addDealExpense(dispatch, props.productIdx, expense);
      }
    },
    updatePaymentExpense(expenseIdx, expense) {
      if (props.dealType == 'transport') {
        updateTransportExpense(dispatch, expenseIdx, expense);
      } else {
        updateDealExpense(dispatch, props.productIdx, expenseIdx, expense);
      }
    },
    removePaymentExpense(expenseIdx) {
      if (props.dealType == 'transport') {
        removeTransportExpense(dispatch, expenseIdx, true);
      } else {
        removeDealExpense(dispatch, props.productIdx, expenseIdx, true);
      }
    },
    setExpensesRebuilded() {
      setExpensesRebuilded(dispatch, props.productIdx);
    },
  })
)(CommonPaymentsContainer);

const SubCommonPaymentsContainer = InternalSubCommonPaymentsContainer;

export default SubCommonPaymentsContainer;
